import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'CareSurround';

const getPageTitle = (pathname: string): string => {
  const path = pathname.replace(/\/$/, '');

  // Handle groups routes (both standalone and org-nested)
  if (path.includes('/groups')) {
    if (path.includes('/new-unit')) return 'New Unit';
    if (path.includes('/unit/')) return 'Unit';
    if (path.match(/\/groups\/\d+$/)) return 'Group';
    return 'Groups';
  }

  // Handle organisation-nested routes
  if (path.startsWith('/organisations/')) {
    if (path.includes('/devices')) return 'Devices';
    if (path.includes('/policies')) return 'Policies';
    if (path.includes('/reporting')) return 'Reporting';
    if (path.includes('/users')) return 'Users';
    if (path.includes('/units')) return 'Units';
    return 'Organisations';
  }

  // Handle top-level routes
  switch (path) {
    case '':
    case '/':
      return 'Home';
    case '/account':
      return 'Account';
    case '/credentials':
      return 'Credentials';
    case '/devices':
      return 'Devices';
    case '/import':
      return 'Import';
    case '/login':
      return 'Login';
    case '/reporting':
      return 'Reporting';
    case '/units':
      return 'Units';
    case '/organisations':
      return 'Organisations';
    default:
      // Handle dynamic routes
      if (path.startsWith('/users')) return 'Users';
      if (path.startsWith('/policies')) return 'Policies';
      return 'Home';
  }
};

export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    document.title = `${pageTitle} | ${BASE_TITLE}`;
  }, [location.pathname]);
};
